import { dialog } from "nq-component";
import BaseFormPresenter from "../../../../../base/BaseFormPresenter";
import DialogModal from "../../../../../components/Dialog";
import {
  computePartialCosts,
  computePartialCostsComponent,
  computeTotalCost,
} from "../../../../../componentCostUtils";

class ProductFormPresenter extends BaseFormPresenter {
  // onChange(value, field) {
  //   this.change[field] = value;
  //   this.object[field] = value;

  //   // Preserve raw_materials if present in the view
  //   if (!this.object.raw_materials && this.view.state.object?.raw_materials) {
  //     this.object.raw_materials = [...this.view.state.object.raw_materials];
  //   }

  //   // if (!this.object.sku && this.view.state.object.sku) {
  //   //   this.object.sku = this.view.state.object.sku;
  //   // }

  //   // if (!this.object.itemName && this.view.state.object.itemName) {
  //   //   this.object.itemName = this.view.state.object.itemName;
  //   // }

  //   this.view.setObject(this.object);
  // }

  onChange(value, field) {
    // track changes
    this.change[field] = value;

    // start from what's already in the view to avoid losing arrays/fields
    const current = this.view.state.object || {};

    // merge: keep everything in current, then any existing presenter fields, then the new field
    const next = { ...current, ...this.object, [field]: value };

    // optional: ensure arrays keep their reference (or clone if you prefer)
    if (
      Array.isArray(current.raw_materials) &&
      !Array.isArray(next.raw_materials)
    ) {
      next.raw_materials = current.raw_materials; // or [...current.raw_materials]
    }

    // keep presenter copy in sync
    this.object = next;

    // update the view
    this.view.setObject(next);
  }

  async getObject() {
    const collection = this.view.getCollectionName();
    const id = this.object.id || this.view.getObjectId();
    if (id) {
      const params = { include: ["raw_materials", "raw_materials.uom", "uom"] };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        this.view.hideProgress();
        this.view.setObject(this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  async save() {
    const collection = this.view.getCollectionName();
    const user = this.view.getCurrentUser();

    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.acl = this.view.getAcl();
    }

    // ✅ Compute updated raw_materials with partial_cost
    const rawMaterials = computePartialCosts(
      this.view.state.object.raw_materials || []
    ).map((item) => {
      const copy = { ...item };
      // delete copy.quantity;
      return copy;
    });

    console.log("eeee", rawMaterials);

    // ✅ Compute updated raw_materials with partial_cost
    const othersRawMaterials = computePartialCosts(
      this.view.state.object.others_raw_materials || []
    ).map((item) => {
      const copy = { ...item };
      // delete copy.quantity;
      return copy;
    });

    // ✅ Assign to this.change
    this.change.raw_materials = rawMaterials;
    this.change.others_raw_materials = othersRawMaterials;

    // ✅ Compute and assign total cost of product
    // this.change.cost = computeTotalCost(rawMaterials);
    this.change.cost = computeTotalCost([
      ...rawMaterials,
      ...othersRawMaterials,
    ]);

    // ✅ Prepare components
    const components = (this.view.state.object.components || []).map((item) => {
      const copy = { ...item };
      if (copy.quantity !== undefined) {
        copy.quantity = parseFloat(copy.quantity);
      }
      delete copy.raw_materials;
      return copy;
    });

    const additionalProducts = this.view.state.object.products || [];

    this.change.components = components;
    this.change.products = additionalProducts;
    // this.change.storeId = { id: user.storeAnalytic[0]?.id };

    console.log("save", this.change);

    try {
      await this.upsertUseCase.execute(collection, this.change);
      this.change = {};
    } catch (error) {
      throw error;
    }
  }

  async submit() {
    // if (Object.values(this.change).length === 0) {
    //   this.view.showSuccessSnackbar("Successfully saved!");
    //   return;
    // }
    try {
      this.view.submitting();
      dialog.close();
      await this.save();

      dialog.fire({
        html: (
          <DialogModal
            icon="bi bi-question-octagon-fill"
            iconColor="#82c14a"
            title="Saved Successfully"
            message=""
            isCancelButton={false}
            onSubmit={() => {
              this.view.navigateBack();
              dialog.close();
            }}
            onClose={() => dialog.close()}
          />
        ),
        footer: false,
      });
    } catch (error) {
      this.view.submissionError(error);
      this.view.showError(error);
    }
  }
}

export default ProductFormPresenter;
